import { Form, Input, Row, Col, Switch, InputNumber, ColorPicker, Select } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const { membershipMarketingPlansId } = data?.sendPageData;
    if (data.type === 'NEW') {
        form.setFieldValue('membershipMarketingPlansId', membershipMarketingPlansId);
    }
    const ref = useRef<any>(undefined);
    const [shopData, setShopData] = useState<any>();
    const [membershipMarketingPlansData, setMembershipMarketingPlansData] = useState<any>();

    useEffect(() => {
        let serviceUrl;
        if (ref.current) {
            serviceUrl = ref.current.defaultService;
        }
        fetchApi.GET(serviceUrl, {
            apiId: 'shop',
            apiExtend: 'showList'
        }).then(res => {
            if (res.success === true) {
                setShopData(res.data);
            }
        })
        fetchApi.GET(serviceUrl, {
            apiId: 'membershipMarketingPlans',
            apiExtend: 'showList'
        }).then(res => {
            if (res.success === true) {
                setMembershipMarketingPlansData(res.data);
            }
        })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'membershipMarketingPlansApplicablesShops',
        serviceId: 'business'
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '营销方案适合店铺'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="ID"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="店铺"
                                name="shopId"
                                rules={[{ required: true, message: '请选择店铺!' }]}>
                                <Select
                                    showSearch
                                    placeholder="店铺"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(shopData, { itemName: 'shopName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="营销方案"
                                name="membershipMarketingPlansId"
                                rules={[{ required: true, message: '请选择营销方案!' }]}>
                                <Select
                                    disabled={true}
                                    showSearch
                                    placeholder="营销方案"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(membershipMarketingPlansData, { itemName: 'planName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;